import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ImportReportCategories, ImportReportRecipient } from "../models/import-report";

const routes = {
  categories: "/v1/import-report/categories",
  recipients: "/v1/import-report/recipients",
  recipient: (id: number) => `/v1/import-report/recipients/${id}`
};

@Injectable({
  providedIn: "root"
})
export class ImportReportService {

  constructor(private http: HttpClient) { }

  getCategories(): Observable<ImportReportCategories> {
    return this.http.get<ImportReportCategories>(routes.categories);
  }

  getRecipients(): Observable<ImportReportRecipient[]> {
    return this.http.get<ImportReportRecipient[]>(routes.recipients);
  }

  addRecipient(recipient: ImportReportRecipient): Observable<ImportReportRecipient> {
    return this.http.post<ImportReportRecipient>(routes.recipients, recipient);
  }

  updateRecipient(id: number, recipient: ImportReportRecipient): Observable<ImportReportRecipient> {
    return this.http.put<ImportReportRecipient>(routes.recipient(id), recipient);
  }

  deleteRecipient(id: number): Observable<any> {
    return this.http.delete(routes.recipient(id));
  }
}
